import { find } from 'lodash';

export const BLACKLIST_CAMEL_CASE = ['/relatorio/templates', '/geral/dashboards'];

export const inBlacklist = (str: string): boolean => {
  const found = find(BLACKLIST_CAMEL_CASE, (s) => str.includes(s));
  if (found) return true;
  return false;
};
